// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"56a8d5bd","203":"b7f70c70","224":"d00e1e7b","228":"fc1c9b62","453":"e9ff7f75","509":"14f1f161","558":"328907f8","636":"f88c32de","729":"b7855e30","747":"c511e977","771":"47ba8a46","987":"d42067f3"}[chunkId] + ".chunk.js";
};